import comp from "./TextMoreLess";
export default comp;
